import { useParams } from 'react-router-dom';
import CameraForm from './CameraForm';
import React from 'react';

export default function EditCamera() {
  let { id } = useParams();
  return <CameraForm id={id} />;
}
